export default {
  calendar: {
    today: 'Hoje',
    tomorrow: 'Amanhã',
    asap: 'Imediato',
  },
};
